module.exports = __webpack_public_path__ + "static/media/CaryLogo.17b875aa.png";